module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/VI-b1cc667d23c3c0c155ea8b0ad36cb326.png";